<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Salary Expectation') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <form v-on:submit.prevent="save(candidateEdit)">
        <div class="form-group">
          <input-money 
            v-model="candidateEdit.salary"
            :locale="$i18n.locale"
            :placeholder="$n(0, {style: 'decimal', minimumFractionDigits: 2})">
            </input-money>
          <ValidateMessage :error="validateErrors.salary" />
        </div>
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
              class="btn btn-primary">
              {{ $t('Save') }}
              </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>
    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
      {{ $n(candidate.salary, {style: 'decimal', minimumFractionDigits: 2}) }}
    </div>
  </div>

</template>

<script>
import _ from 'lodash'
import InputMoney from '@/components/Fields/InputMoney'

export default {
  name: 'CandidateProfileSalary',
  components: {
    InputMoney
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    filled () {
      return this.candidate.salary
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = _.pick(this.candidate, [
        '_id',
        'salary'
      ])
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileSalary.vue